import React from 'react';

// Building blocks for Knowledge articles. Articles are JSX-as-content
// (lib/knowledge/*) — these keep that JSX terse and visually consistent.
// Deliberately auth-free: RoleChips lives in RoleChips.jsx so that articles
// (and the registry) never pull the MSAL-backed AuthContext into their
// import graph.

// Panel-chromed article section, staggered in with the app-wide reveal idiom.
export function KbSection({ title, delay = 0, children }) {
  return (
    <section className={`panel reveal${delay ? ` delay-${delay}` : ''}`} style={{ marginBottom: 16 }}>
      {title && (
        <div className="panel-head">
          <div className="panel-title">{title}</div>
        </div>
      )}
      <div className="panel-body kb-prose">{children}</div>
    </section>
  );
}

// Gate a fragment of an article to a sub-audience, e.g. the cost-edit part of
// the costs article. Mirrors the app's own `user?.canX` conditional idiom.
export function VisibleTo({ user, when, children }) {
  return when(user) ? children : null;
}

// Reuses the app's .callout family (info | warn | brand | danger).
export function Callout({ tone = 'info', children }) {
  return (
    <div className={`callout ${tone}`} style={{ margin: '12px 0' }}>
      <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
        <circle cx="12" cy="12" r="10" />
        <line x1="12" y1="16" x2="12" y2="12" />
        <line x1="12" y1="8" x2="12.01" y2="8" />
      </svg>
      <div>{children}</div>
    </div>
  );
}

// Numbered how-to steps — the workhorse of most articles.
export function StepList({ steps }) {
  return (
    <ol className="kb-steps">
      {steps.map((s, i) => <li key={i}>{s}</li>)}
    </ol>
  );
}
